module.exports = __webpack_public_path__ + "static/media/frickfoyer.033311c2.png";